import { alpha, SxProps, Theme } from '@mui/material/styles';

export const content: SxProps<Theme> = {
  flexGrow: 1,
  pr: 2,
  pl: 2,
  pt: 2,
  pb: 0,
};

export const flexRow: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const topBar: SxProps<Theme> = {
  ...flexRow,
  width: '100%',
};

export const topBarWrapper: SxProps<Theme> = {
  ...topBar,
  flexDirection: 'column',
  alignItems: 'flex-start',
};

export const topBarTitle: SxProps<Theme> = {
  my: 2,
  flexGrow: 1,
  // textAlign: 'start',
  fontWeight: '400',
};

export const loadingBox: SxProps<Theme> = {
  ...flexRow,
  height: '100%',
  backgroundColor: '#ccc',
  justifyContent: 'center',
};

export const loadingBoxWhite: SxProps<Theme> = {
  ...flexRow,
  height: '100%',
  justifyContent: 'center',
};

export const actionButtons: SxProps<Theme> = {
  ...flexRow,
  width: '100%',
  alignItems: 'flex-start',
};

export const bottomBarButtons: SxProps<Theme> = {
  color: (theme) => theme.palette.secondary.variants[10],
};

export const bottomBar: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  p: 1,
  backgroundColor: (theme) => theme.palette.primary.main,
};

export const bottomBarMenu: SxProps<Theme> = {
  '& ul': {
    padding: 0,
    background: (theme) => theme.palette.primary.variants[90],
  },
  '& .MuiPaper-root': {
    transform: 'translateY(-8px)',
  },
};

export const inLineForm: SxProps<Theme> = {
  ...flexRow,
  width: '100%',
  justifyContent: 'flex-start',
};

export const flexColumn: SxProps<Theme> = {
  ...flexRow,
  flexDirection: 'column',
};

export const flexRowGrow: SxProps<Theme> = {
  ...flexRow,
  flexGrow: 1,
};

export const topBarOverList: SxProps<Theme> = {
  ...flexRowGrow,
  justifyContent: 'flex-start',
  gap: 2,
  mb: 2,
};

export const topBarOverListWithScrollX: SxProps<Theme> = {
  ...flexRowGrow,
  mb: 2,
  overflowX: 'auto',
  whiteSpace: 'nowrap',
  gap: '8px',
  paddingBottom: '8px',
  justifyContent: 'flex-start',
};

export const fullWidthButton: SxProps<Theme> = {
  mt: 3,
  width: '100%',
};

export const formCard: SxProps<Theme> = {
  width: '100%',
  backgroundColor: (theme) => theme.palette.formCard.main,
  mt: 2,
  mb: 2,
};

export const formCardContent: SxProps<Theme> = {
  maxHeight: 350,
  overflow: 'auto', // Changed from 'scroll' to 'auto' for better UX
};

export const metabaseAppEmbed: React.CSSProperties = {
  height: 3500,
};

export const geoPicker: SxProps<Theme> = {
  height: 350,
  width: '100%',
  mt: 0,
};

export const mobileCard: SxProps<Theme> = (theme) => ({
  p: 1,
  mb: 1,
  borderColor: theme.palette['surface-background'].main,
  backgroundColor: theme.palette['surface-background'].main,
});

export const loginInput: SxProps<Theme> = {
  backgroundColor: '#FFFFFFBB',
};

export const loginFooter: SxProps<Theme> = {
  backgroundColor: 'white',
  display: 'flex',
  padding: '10px',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: 'unset !important',
  width: '100%',
};

export const detailDadosBasicos: Record<string, SxProps<Theme>> = {
  sxSectionTitle: {
    color: (theme) => theme.palette.primary.main,
    fontSize: 14,
    minHeight: 24,
    boxShadow: 'none',
    margin: 0,
    padding: 0,
  },
  sxLabel: {
    fontSize: 12,
    letterSpacing: 1.1,
    color: (theme) => theme.palette.text.variant,
  },
  sxValue: {
    fontSize: 14,
    letterSpacing: 1.1,
    color: (theme) => theme.palette.text.variant,
    mt: 1,
  },
  sxRow: { mb: 2 },
};
export const detailAccordion: Record<string, SxProps<Theme>> = {
  sxSectionTitle: {
    color: (theme) => theme.palette.primary.main,
    fontSize: 22,
    // boxShadow: 'none',
    margin: 0,
    padding: 0,
  },
  sxLabel: {
    fontSize: 12,
    letterSpacing: 1.1,
    color: (theme) => theme.palette.text.variant,
  },
  sxValue: {
    fontSize: 16,
    letterSpacing: 1.1,
    color: (theme) => theme.palette.text.variant,
    mt: 0.5,
  },
  sxRow: {
    backgroundColor: (theme) => theme.palette.primary.variants[95],
    p: 2,
    mb: 2,
  },
};
export const detailNonAccordion: Record<string, SxProps<Theme>> = {
  sxSectionTitle: {
    color: (theme) => theme.palette.primary.main,
    fontSize: 22,
    fontWeight: 400,
    padding: '0 16',
  },
  sxLabel: {
    fontSize: 12,
    letterSpacing: 1.1,
    color: (theme) => theme.palette.text.variant,
  },
  sxValue: { fontSize: 16, letterSpacing: 1.1, mt: 0.5 },
  sxRow: {
    backgroundColor: (theme) => theme.palette.primary.variants[95],
    p: 2,
    mb: 2,
  },
};

export const formLayout: Record<string, SxProps<Theme>> = {
  sxSectionTitle: {
    color: (theme) => theme.palette.primary.main,
    fontSize: 22,
    fontWeight: 400,
    padding: '0 16',
  },
  sxLabel: {
    fontSize: 12,
    letterSpacing: 1.1,
    color: (theme) => theme.palette.text.variant,
  },
  sxValue: { fontSize: 16, letterSpacing: 1.1, mt: 0.5 },
  // sxRow: {
  //   backgroundColor: (theme) => theme.palette.primary.variants[95],
  //   p: 2,
  //   mb: 2,
  // },
};

export const mobileStepper: SxProps<Theme> = {
  maxWidth: '100%',
  flexGrow: 1,
  display: 'grid',
  gridTemplateColumns: '102px 1fr 102px',
  pt: 3,
  background: 'transparent',
  '& .MuiLinearProgress-root': {
    gridColumn: '1/4',
    gridRow: 1,
    marginBottom: 2,
    width: '100%',
  },
  '& .MuiButton-root': {
    borderRadius: '100px',
  },
};

export const stepNumbers: SxProps<Theme> = (theme) => ({
  color: theme.palette.primary.main,
  position: 'absolute',
  right: 0,
  bottom: '80px',
  pr: 3,
});

export const sideBarItem: SxProps<Theme> = (theme) => ({
  color: theme.palette.primary.contrastText,
});

export const sideBarItemIcon: SxProps<Theme> = (theme) => ({
  color: theme.palette.primary.contrastText,
  minWidth: 'unset',
  marginRight: 4,
});

export const sideBarDivider: SxProps<Theme> = (theme) => ({
  borderColor: theme.palette.primary.contrastText,
  marginTop: 1,
  marginBottom: 1,
});

export const productionCardIcon: SxProps<Theme> = (theme) => ({
  color: theme.palette.icon.primary,
});

export const productionCardValue: SxProps<Theme> = (theme) => ({
  color: theme.palette.primary.light,
});

export const productionCardChip: SxProps<Theme> = {
  marginTop: 1,
};

export const productionCardIconWrapper: SxProps<Theme> = (theme) => ({
  p: 1,
  backgroundColor: theme.palette.primary.variants[90],
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const productionCardContent: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 2,
};

export const productionCardActionWrapper: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  gap: 2,
};

export const productionCardActionSingle: SxProps<Theme> = {
  width: '100%',
  margin: '12px 0',
};

export const productionDetailCardIconWrapper: SxProps<Theme> = (theme) => ({
  p: 1,
  backgroundColor: theme.palette.primary.variants[90],
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 40,
});

export const productionDetailCardContent: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const homeTotals =
  ({ capa }: { capa: string }): SxProps<Theme> =>
  (theme) => ({
    mt: 4,
    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url('${capa}')`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundAttachment: 'fixed',
    backgroundBlendMode: 'darken',
    minHeight: 'calc(100vh - 140px)',
  });

export const homeTotalsInner: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  padding: '16px',
  gap: '48px',
};

export const homeTotalsCardTitle: SxProps<Theme> = {
  display: 'block',
  textAlign: 'center',
  fontSize: '24px',
  mb: 0,
  pb: 0,
};

export const homeTotalsCardSubTitle: SxProps<Theme> = {
  display: 'block',
  textAlign: 'center',
  fontSize: '20px',
  mt: 0,
};

export const homeTotalsCardContent: SxProps<Theme> = {
  display: 'flex',
  p: 1,
  pt: 3,
  alignItems: 'center',
  gap: 1,
};

export const homeTotalsIconWrapper: SxProps<Theme> = (theme) => ({
  p: 1,
  backgroundColor: theme.palette.primary.variants[90],
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const homeTotalsIcon: SxProps<Theme> = (theme) => ({
  color: theme.palette.icon.primary,
  margin: '4px',
});

export const BottomInfoContainer: SxProps<Theme> = (theme) => ({
  position: 'fixed',
  bottom: '0',
  left: 0,
  padding: 2,
  backgroundColor: theme.palette.primary.variants['90'],
  color: theme.palette.secondary.variants['10'],
});
export const BottomInfoContainerDesktop: SxProps<Theme> = (theme) => ({
  position: 'absolute',
  top: 4,
  left: 0,
  padding: 2,
  backgroundColor: theme.palette.primary.variants['90'],
  color: theme.palette.secondary.variants['10'],
});
export const BottomInfoContainerCard: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.primary.variants['90'],
  color: theme.palette.text.variant,
});

export const TotalsCardWrapper = (props?: { isMobile: boolean }): SxProps<Theme> => ({
  display: 'flex',
  ...(props?.isMobile
    ? {
        mt: 2,
        flexDirection: 'column',
        gap: 6,
      }
    : {
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
      }),
});

export const TotalsGroup: SxProps<Theme> = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  color: theme.palette.primary.contrastText,
  backgroundColor: alpha(theme.palette['surface-background'].main, 0.25),
  borderRadius: 4,
  padding: 2,
  // ...(!isFirst && {
  //   pt: 6,
  //   borderTopColor: theme.palette.primary.contrastText,
  //   borderTopWidth: 2,
  //   borderTopStyle: 'solid',
  // }),
});

export const IconMenu: SxProps<Theme> = {
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
  mt: 1.5,
  '& .MuiAvatar-root': {
    width: 32,
    height: 32,
    ml: -0.5,
    mr: 1,
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 14,
    width: 10,
    height: 10,
    bgcolor: 'background.paper',
    transform: 'translateY(-50%) rotate(45deg)',
    zIndex: 0,
  },
};
